export enum AlertTypes {
  INFO,
  WARNING,
}

export enum AlertSizes {
  S,
  M,
  L,
}
